module.exports = __webpack_public_path__ + "static/media/Mew_gaussian2.20506936.png";